import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Loadable from 'react-loadable';

import Map from './Map';

import * as mapAction from '../actions/mapActions';
import * as appAction from '../actions/appActions';

/**
 * Components that are loaded through code splitting
 */
const Categories = Loadable({
  loader: () => import('./Categories'),
  loading: () => null,
});

const LoadingView = Loadable({
  loader: () => import('./LoadingView'),
  loading: () => null,
});

class Body extends Component {
  constructor(props) {
    super();
    this.state = {
    };
    this.categoriesFilters = [];
    this.categoriesHandleChange = this.categoriesHandleChange.bind(this);
  }

  async componentDidMount() {
    const { mapActions, appActions } = this.props;
    const { REACT_APP_LOCATION } = process.env;
    /**
     * Make the async call to get the general info of the viz
     */
    await appActions.getGeneralInfo();

    // ----- Start the fetch of categories
    mapActions.getCategoryData('years');
    mapActions.getCategoryData('severity');
    mapActions.getCategoryData('categories_factors');
    mapActions.getCategoryData('weather');
    mapActions.getCategoryData('categories_vehicles');

    /**
     * This conditional decide if there is something in the url parameters to be fetched or
     * If is needed the default fetch
     */
    const results = this.getUrlParams();
    if (results && results.length > 0) {
      await mapActions.getFilteredData(results);
    } else {
      const params = REACT_APP_LOCATION === 'corpus_christi' ? ['vehicles=Pedestrian'] : ['incident_year=2017'];
      this.categoriesFilters.push(...params);
      await mapActions.getFilteredData(params);
    }
  }

  /**
   * Method that get the parameters of the URL if exist
   */
  getUrlParams = () => {
    const URL_STRING = window.location.href;
    const urlDecoded = decodeURI(URL_STRING);
    const refParams = ['incident_year', 'factors', 'severity', 'weather_condition', 'vehicles'];
    const params = urlDecoded.split('?')[1];
    if (params && params.length > 0) {
      const arr = params.split('&');
      const validate = arr.filter(el => refParams.includes(el.split('=')[0]));
      this.categoriesFilters.push(...validate);
      return validate;
    }
    return null;
  }

  /**
   * Method that allow to set the state of the loading component
   */
  updateLoading = (state) => {
    const { mapActions } = this.props;
    mapActions.updateLoadingState(state);
  }

  /**
    * Fetch the data to the server if there is a new category selected with his corresponding value
    */
  async categoriesHandleChange(category, selectedOption) {
    const { mapActions } = this.props;

    this.categoriesFilters = this.categoriesFilters.filter(value => !value.includes(`${category}=`));
    if (selectedOption.value !== 0) {
      this.categoriesFilters.push(`${category}=${selectedOption.value}`);
    }
    await mapActions.getFilteredData(this.categoriesFilters);
  }

  render() {
    const {
      vizInfo,
      incidentsFiltered,
      categories,
      loading,
      infoReady,
      selectedFilters,
    } = this.props;

    return (
      <div className="body">
        {loading && (
        <LoadingView />
        )}

        {selectedFilters && (
        <Categories
          categories={categories}
          handleChange={this.categoriesHandleChange}
          selectedFilters={selectedFilters}
        />
        )}

        {infoReady && (
        <Map
          vizParams={vizInfo}
          incidentsData={incidentsFiltered}
          updateLoading={this.updateLoading}
        />
        )}

      </div>
    );
  }
}

const propTypes = {
  mapActions: PropTypes.objectOf(PropTypes.func).isRequired,
  appActions: PropTypes.objectOf(PropTypes.func).isRequired,
  vizInfo: PropTypes.objectOf(PropTypes.shape).isRequired,
  incidentsFiltered: PropTypes.objectOf(PropTypes.shape),
  loading: PropTypes.bool.isRequired,
  infoReady: PropTypes.bool.isRequired,
  categories: PropTypes.objectOf(PropTypes.shape).isRequired,
  selectedFilters: PropTypes.string.isRequired,
};

const defaultProps = {
  incidentsFiltered: {},
};

const mapStateToProps = state => ({
  vizInfo: state.app.vizInfo,
  incidentsFiltered: state.map.incidentsFiltered,
  categories: state.map.categories,
  loading: state.map.loading,
  infoReady: state.app.infoReady,
  selectedFilters: state.map.selectedFilters,
});

const mapDispatchToProps = dispatch => ({
  mapActions: bindActionCreators(mapAction, dispatch),
  appActions: bindActionCreators(appAction, dispatch),
});

Body.propTypes = propTypes;
Body.defaultProps = defaultProps;

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Body);
